import {
  CUBIC_METERS_PER_METRIC_MILLION_BRITISH_THERMAL_UNITS,
  LITERS_PER_GALLON,
  MEGAJOULES_PER_KILO_BRITISH_THERMAL_UNITS,
  MEGAWATT_HOURS_PER_KILOWATT_HOURS,
  METRIC_TONS_PER_POUND,
  SQUARE_METERS_PER_SQUARE_FOOT,
} from "./constants"

export const gallonsToLiters = (value: number) => value * LITERS_PER_GALLON

export const kiloBritishThermalUnitsToMegajoules = (value: number) =>
  value * MEGAJOULES_PER_KILO_BRITISH_THERMAL_UNITS

export const kiloBritishThermalUnitsPerSquareFootToMegajoulesPerSquareMeter = (
  value: number
) =>
  (value * MEGAJOULES_PER_KILO_BRITISH_THERMAL_UNITS) /
  SQUARE_METERS_PER_SQUARE_FOOT

export const kilowattHoursToMegawattHours = (value: number) =>
  value * MEGAWATT_HOURS_PER_KILOWATT_HOURS

export const metricMillionBritishThermalUnitsPerSquareFootToCubicMetersPerSquareMeter =
  (value: number) =>
    (value * CUBIC_METERS_PER_METRIC_MILLION_BRITISH_THERMAL_UNITS) /
    SQUARE_METERS_PER_SQUARE_FOOT

export const metricMillionBritishThermalUnitsToCubicMeters = (value: number) =>
  value * CUBIC_METERS_PER_METRIC_MILLION_BRITISH_THERMAL_UNITS

export const poundsToMetricTons = (value: number): number =>
  value * METRIC_TONS_PER_POUND

export const squareFeetToSquareMeters = (value: number): number =>
  value * SQUARE_METERS_PER_SQUARE_FOOT

export const squareMetersToSquareFeet = (value: number): number =>
  value / SQUARE_METERS_PER_SQUARE_FOOT
